// extracted by mini-css-extract-plugin
export default {"ifLayout":"AddressInput_ifLayout__P3eyE","inputHeight":"AddressInput_inputHeight__FsPB-"};